import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page d-flex flex-row flex-column-fluid" }
const _hoisted_2 = {
  id: "kt_wrapper",
  class: "d-flex flex-column flex-row-fluid wrapper"
}
const _hoisted_3 = {
  id: "kt_content",
  class: "content d-flex flex-column flex-column-fluid"
}
const _hoisted_4 = { class: "post d-flex flex-column-fluid" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { className: "card card-custom" }
const _hoisted_7 = { className: "card-body pt-2" }
const _hoisted_8 = { className: "d-flex flex-wrap align-items-center" }
const _hoisted_9 = { className: "d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3" }
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: "media/logos/Pryal Horizontal Tagline.png",
  class: "mw-200px mb-5"
}, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 d-flex flex-column align-items-center py-5" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", null, "Parecer final", -1)
const _hoisted_16 = { class: "d-flex align-items-center text-center text-dark" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex align-items-center mt-3"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-download fs-4 me-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = { class: "fs-9" }
const _hoisted_21 = { class: "mt-5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "fs-8 text-muted" }, "Data do laudo ", -1)
const _hoisted_23 = { class: "fs-8" }
const _hoisted_24 = /*#__PURE__*/_createVNode("hr", { class: "mt-5" }, null, -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-6 col-lg-12 mb-3" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "\n                                  col-lg-5\n                                  fs-5\n                                  fw-bold\n                                  align-middle\n                                  text-muted\n                                " }, "Marca", -1)
const _hoisted_29 = { class: "col-lg-7 fs-5 fw-bold text-dark" }
const _hoisted_30 = { class: "col-6 col-lg-12 mb-3" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { class: "\n                                  col-lg-5\n                                  fs-5\n                                  fw-bold\n                                  align-middle\n                                  text-muted\n                                " }, "Modelo", -1)
const _hoisted_33 = { class: "col-lg-7 fs-5 fw-bold text-dark" }
const _hoisted_34 = { class: "col-6 col-lg-12 mb-3" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", { class: "\n                                  col-lg-5\n                                  fs-5\n                                  fw-bold\n                                  align-middle\n                                  text-muted\n                                " }, "Km", -1)
const _hoisted_37 = { class: "col-lg-7 fs-5 fw-bold text-dark" }
const _hoisted_38 = { class: "col-6 col-lg-12 mb-3" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "\n                                  col-lg-5\n                                  fs-5\n                                  fw-bold\n                                  align-middle\n                                  text-muted\n                                " }, "Ano Fab/Mod", -1)
const _hoisted_41 = { class: "col-lg-7 fs-5 fw-bold text-dark" }
const _hoisted_42 = { class: "col-6 col-lg-12 mb-3" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { class: "\n                                  col-lg-5\n                                  fs-5\n                                  fw-bold\n                                  align-middle\n                                  text-muted\n                                " }, "Placa", -1)
const _hoisted_45 = { class: "col-lg-7 fs-5 fw-bold text-dark" }
const _hoisted_46 = { class: "col-6 col-lg-12 mb-3" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { class: "\n                                  col-lg-5\n                                  fs-5\n                                  fw-bold\n                                  align-middle\n                                  text-muted\n                                " }, "Chassi", -1)
const _hoisted_49 = { class: "col-lg-7 fs-5 fw-bold text-dark" }
const _hoisted_50 = { class: "col-6 col-lg-12 mb-3" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { class: "\n                                  col-lg-5\n                                  fs-5\n                                  fw-bold\n                                  align-middle\n                                  text-muted\n                                " }, "Renavam", -1)
const _hoisted_53 = { class: "col-lg-7 fs-5 fw-bold text-dark" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "row d-block d-lg-none" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_55 = { class: "col-lg-6" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-lg-7" }
const _hoisted_58 = {
  class: "card border border-2 position-relative",
  style: {"border-color":"#15151e !important"}
}
const _hoisted_59 = { className: "card-body p-3" }
const _hoisted_60 = {
  class: "\n                                    d-flex\n                                    justify-content-center\n                                    flex-grow-1\n                                    py-1\n                                    position-relative\n                                  ",
  style: {"background-color":"#15151e"}
}
const _hoisted_61 = /*#__PURE__*/_createVNode("div", {
  class: "\n                                      bg-white\n                                      p-2\n                                      rounded\n                                      border border-3\n                                      position-absolute\n                                    ",
  style: {"top":"-7px","left":"-5px","border-color":"#15151e !important"}
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "media/logos/Pryal P.png",
    class: "mw-30px"
  })
], -1)
const _hoisted_62 = { class: "text-white" }
const _hoisted_63 = {
  class: "\n                                    d-flex\n                                    justify-content-center\n                                    flex-grow-1\n                                    py-1\n                                    position-relative\n                                    rounded-bottom\n                                  ",
  style: {"background-color":"#15151e"}
}
const _hoisted_64 = { class: "text-white" }
const _hoisted_65 = {
  key: 0,
  class: "badge badge-circle badge-white me-1"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("i", { class: "fa fa-exclamation-triangle  text-warning" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "\n                                  position-absolute\n                                  top-100\n                                  start-50\n                                  translate-middle\n                                " }, [
  /*#__PURE__*/_createVNode("label", { class: "bg-white" }, [
    /*#__PURE__*/_createVNode("img", {
      src: "media/logos/Pryal Horizontal.png",
      class: "mw-50px"
    })
  ])
], -1)
const _hoisted_68 = { class: "col-lg-5" }
const _hoisted_69 = { class: "card-title text-center" }
const _hoisted_70 = { class: "text-warning pt-3" }
const _hoisted_71 = { class: "px-3 d-flex flex-column" }
const _hoisted_72 = /*#__PURE__*/_createVNode("span", { class: "bullet bg-warning" }, null, -1)
const _hoisted_73 = { class: "col-lg-8" }
const _hoisted_74 = { class: "card border mb-3" }
const _hoisted_75 = { className: "card-body d-flex flex-column" }
const _hoisted_76 = { class: "col-lg-5 col-md-6" }
const _hoisted_77 = { class: "col-lg-4" }
const _hoisted_78 = {
  key: 0,
  class: "card border mb-3"
}
const _hoisted_79 = { className: "card-body" }
const _hoisted_80 = /*#__PURE__*/_createVNode("h3", null, "Fotos", -1)
const _hoisted_81 = { class: "row images cursor" }
const _hoisted_82 = {
  key: 1,
  class: "mw-200px me-1",
  controls: ""
}
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "text-center fw-bold text-dark" }, [
  /*#__PURE__*/_createTextVNode(" PRYAL CERTIFICACAO AUTOMOTIVA LTDA "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 41.793.240/0001-78")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_viewer = _resolveDirective("viewer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode("div", _hoisted_13, [
                          _createVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createVNode("span", _hoisted_16, _toDisplayString(_ctx.model.laudo.parecerFinal), 1),
                            (_ctx.model.laudo.documentos.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.laudo.documentos, (doc, index) => {
                                    return (_openBlock(), _createBlock("div", { key: index }, [
                                      _createVNode("a", {
                                        href: doc.url,
                                        target: "_blank",
                                        class: "btn btn-sm btn-secondary "
                                      }, [
                                        _hoisted_18,
                                        _hoisted_19,
                                        _createVNode("span", _hoisted_20, _toDisplayString(doc.nome), 1)
                                      ], 8, ["href"])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("span", _hoisted_21, [
                              _hoisted_22,
                              _createVNode("span", _hoisted_23, _toDisplayString(_ctx.model.laudo.data), 1)
                            ])
                          ]),
                          _hoisted_24
                        ]),
                        _createVNode("div", _hoisted_25, [
                          _createVNode("div", _hoisted_26, [
                            _createVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createVNode("label", _hoisted_29, _toDisplayString(_ctx.model.laudo.marca), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_30, [
                            _createVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _createVNode("label", _hoisted_33, _toDisplayString(_ctx.model.laudo.modelo), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_34, [
                            _createVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _createVNode("label", _hoisted_37, _toDisplayString(_ctx.model.laudo.quilometragem), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_38, [
                            _createVNode("div", _hoisted_39, [
                              _hoisted_40,
                              _createVNode("label", _hoisted_41, _toDisplayString(_ctx.model.laudo.anoFabricacao) + " / " + _toDisplayString(_ctx.model.laudo.anoModelo), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _hoisted_44,
                              _createVNode("label", _hoisted_45, _toDisplayString(_ctx.model.laudo.placa), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_46, [
                            _createVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createVNode("label", _hoisted_49, _toDisplayString(_ctx.model.laudo.chassi), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_50, [
                            _createVNode("div", _hoisted_51, [
                              _hoisted_52,
                              _createVNode("label", _hoisted_53, _toDisplayString(_ctx.model.laudo.renavam), 1)
                            ])
                          ])
                        ]),
                        _hoisted_54
                      ]),
                      _createVNode("div", _hoisted_55, [
                        _createVNode("div", _hoisted_56, [
                          _createVNode("div", _hoisted_57, [
                            _createVNode("div", _hoisted_58, [
                              _createVNode("div", _hoisted_59, [
                                _createVNode("div", _hoisted_60, [
                                  _hoisted_61,
                                  _createVNode("span", _hoisted_62, _toDisplayString(_ctx.model.laudo.marca), 1)
                                ]),
                                _createVNode("img", {
                                  class: "mw-100",
                                  src: _ctx.model.laudo.imagem,
                                  alt: ""
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_63, [
                                  _createVNode("span", _hoisted_64, _toDisplayString(_ctx.model.laudo.modelo), 1)
                                ]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.laudo
                                    .categorias, (categoria, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: ["\n                                    rounded\n                                    p-2\n                                    d-flex\n                                    justify-content-between\n                                    mt-3\n                                    position-relative\n                                  ", [
                                    _ctx.getItemsOk(categoria.items) ==
                                    categoria.items.length
                                      ? 'bg-success'
                                      : 'bg-warning'
                                  ]],
                                    key: index
                                  }, [
                                    _createVNode("label", null, _toDisplayString(_ctx.getTextoCorreto(categoria.categoria)), 1),
                                    _createVNode("label", null, [
                                      (_ctx.getItemsOk(categoria.items) !== categoria.items.length)
                                        ? (_openBlock(), _createBlock("span", _hoisted_65, [
                                            _hoisted_66
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(_toDisplayString(_ctx.getItemsOk(categoria.items)) + "/" + _toDisplayString(categoria.items.length), 1)
                                    ])
                                  ], 2))
                                }), 128)),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.laudo
                                    .categorias, (categoria, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: ["\n                                    rounded\n                                    p-2\n                                    d-flex\n                                    justify-content-between\n                                    mt-3\n                                    d-none\n                                  ", [
                                    _ctx.getItemsOk(categoria.items) ==
                                    categoria.items.length
                                      ? 'bg-success'
                                      : 'bg-warning'
                                  ]],
                                    key: index
                                  }, [
                                    _createVNode("label", null, _toDisplayString(_ctx.getTextoCorreto(categoria.categoria)), 1),
                                    _createVNode("label", null, _toDisplayString(_ctx.getItemsOk(categoria.items)) + "/" + _toDisplayString(categoria.items.length), 1)
                                  ], 2))
                                }), 128))
                              ]),
                              _hoisted_67
                            ])
                          ]),
                          _createVNode("div", _hoisted_68, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCategoriaComProblema(
                                _ctx.model.laudo.categorias
                              ), (categoria, index) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "card border border-warning my-3 pb-3",
                                key: index
                              }, [
                                _createVNode("div", _hoisted_69, [
                                  _createVNode("h3", _hoisted_70, _toDisplayString(_ctx.getTextoCorreto(categoria.categoria)), 1)
                                ]),
                                _createVNode("div", _hoisted_71, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getItemsComProblema(
                                    categoria.items
                                  ), (item, indexItem) => {
                                    return (_openBlock(), _createBlock("span", {
                                      key: indexItem,
                                      role: "button",
                                      onClick: ($event: any) => (_ctx.goToMensagemProblema(item.item))
                                    }, [
                                      _hoisted_72,
                                      _createTextVNode(" " + _toDisplayString(item.item), 1)
                                    ], 8, ["onClick"]))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.model.laudo.categorias, (categoria, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "row",
                        key: index
                      }, [
                        _createVNode("div", _hoisted_73, [
                          _createVNode("div", _hoisted_74, [
                            _createVNode("div", _hoisted_75, [
                              _createVNode("h3", null, _toDisplayString(_ctx.getTextoCorreto(categoria.categoria)), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(categoria.items, (item, indexItem) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: ["row", {'bg-light': indexItem % 2 != 0}],
                                  key: indexItem,
                                  id: _ctx.removeWhiteSpace(item.item)
                                }, [
                                  _createVNode("span", {
                                    onClick: ($event: any) => (_ctx.goToMensagemProblema(item.item)),
                                    class: ["col-lg-7 col-md-6", [
                                  item.positivo
                                    ? 'text-success'
                                    : 'text-warning'
                                ]],
                                    role: "button"
                                  }, [
                                    _createVNode("i", {
                                      class: ["fas", [
                                    item.positivo
                                      ? 'text-success fa-check-circle'
                                      : 'text-warning fa-exclamation-triangle'
                                  ]]
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(item.item), 1)
                                  ], 10, ["onClick"]),
                                  _createVNode("span", _hoisted_76, _toDisplayString(item.observacao), 1)
                                ], 10, ["id"]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_77, [
                          (_ctx.getImagensCategoria(
                                  categoria.categoria
                                ).length > 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_78, [
                                _createVNode("div", _hoisted_79, [
                                  _hoisted_80,
                                  _withDirectives(_createVNode("div", _hoisted_81, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getImagensCategoria(
                                  categoria.categoria
                                ), (img) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "col-6 p-2",
                                        key: img.imagem
                                      }, [
                                        (_ctx.isImage(img.imagem))
                                          ? (_openBlock(), _createBlock("img", {
                                              key: 0,
                                              class: "mw-100 me-1",
                                              role: "button",
                                              id: _ctx.removeWhiteSpace(img.item),
                                              alt: img.item,
                                              src: img.imagem
                                            }, null, 8, ["id", "alt", "src"]))
                                          : (_openBlock(), _createBlock("video", _hoisted_82, [
                                              _createVNode("source", {
                                                src: img.imagem
                                              }, null, 8, ["src"])
                                            ])),
                                        _createVNode("p", null, _toDisplayString(img.item), 1)
                                      ]))
                                    }), 128))
                                  ], 512), [
                                    [_directive_viewer]
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    _hoisted_83
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}